'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';

type Language = 'vi' | 'bn';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  isTestingVi: boolean;
  toggleLanguage: () => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export function LanguageProvider({ 
  children, 
  initialLanguage = 'vi' 
}: { 
  children: React.ReactNode;
  initialLanguage?: Language;
}) {
  const [language, setLanguage] = useState<Language>(initialLanguage);

  const toggleLanguage = () => {
    setLanguage(prev => (prev === 'bn' ? 'vi' : 'bn'));
  };

  const isTestingVi = language === 'vi';

  return (
    <LanguageContext.Provider value={{ language, setLanguage, isTestingVi, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
